<template>


  <div class="subgroup flex justify-between items-center" @click="onPOIClick">
    <div class="flex gap-12 items-center">
      <img v-if="poi.getIconUrl()" :src="poi.getIconUrl() ?? poi.getIconUrl()" class="h-46"/> 
      <span>{{ poi.getName(language) }}</span>
    </div>
    <div class="open-pois justify-self-end">
      <div class="flex justify-between items-center">
        <div v-if="poi.getFloor()" class="mr-10 poi-floor-name">
          {{poi.getFloor().getName(language)}}
        </div>
        <svg class="h-18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.63281 9.88379C10.1211 9.39551 10.1211 8.60254 9.63281 8.11426L2.13281 0.614259C1.64453 0.125977 0.851561 0.125977 0.36328 0.614259C-0.125001 1.10254 -0.125001 1.89551 0.36328 2.38379L6.98047 9.00098L0.367187 15.6182C-0.121094 16.1064 -0.121094 16.8994 0.367187 17.3877C0.855469 17.876 1.64844 17.876 2.13672 17.3877L9.63672 9.8877L9.63281 9.88379Z" fill="#0F417C"/>
        </svg>
      </div>

    </div>
  </div>

</template>
<script>
import { mapState } from 'vuex';

export default {
    computed: {
		...mapState('wf', ['language']),
	},
    props: {
        poi: {
            default: null,
            type: Object
        }
    },
    methods: {
        onPOIClick () {
            this.$emit('onPOIClick', this.poi);
        },
        getFirstGroup(poi) {
            if(typeof poi === "object") {
                return poi.getGroupNames().length > 0 ? poi.getGroupNames()[0] : '';
            }

            return "";
        }
	}
}
</script>

<style lang="postcss">
    .list-poi {
        .wf-poi {
            display: flex;
            align-items: center;
            flex-direction: row;
            gap: 1.6rem;
        }

        .wf-poi-image {
            width: 5.6rem;
            height: 3.2rem;
            background-repeat: no-repeat;
            background-position: center;
            background-size: contain;
        }

        .group-label {
            background-color: var(--th-neutral);
        }
    }
</style>